export const config = {
  API_HOST: '/api/',
};

export default config;
